/** SESSIONS */
const SharedSessionUtilities = require("./sessions/SharedSessionUtilities");
const SharedSessionConstants = require("./sessions/SharedSessionConstants");

/** USERS */
const SharedUserUtilities = require("./users/SharedUserUtilities");

/** SUBSCRIPTIONS */
const SharedSubscriptionConstants = require("./subscriptions/SharedSubscriptionConstants");
const SharedSubscriptionUtilities = require("./subscriptions/SharedSubscriptionUtilities");

const SharedModule = {
  /** SESSIONS */
  SharedSessionUtilities,
  SharedSessionConstants,

  /** USERS */
  SharedUserUtilities,

  /** SUBSCRIPTIONS */
  SharedSubscriptionConstants,
  SharedSubscriptionUtilities,
};
module.exports = SharedModule;
